var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 mb-2"},[_c('h5',{staticClass:"mt-1 mb-2 uk-text-bold",attrs:{"for":""}},[_vm._v("Location")]),_c('hr')])])
}]

export { render, staticRenderFns }